module.exports = __webpack_public_path__ + "static/media/piyusha_vidhale.d1eb55ab.png";